import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { useThemeContext } from "../../contexts/theme/useThemeContext";

type Props = {
  open: boolean;
  handleClose: () => void;
  title?: string;
  message?: string;
};

export const AlertDialog = ({ open, handleClose, title, message }: Props) => {
  const { muiTheme } = useThemeContext();

  return (
    <ThemeProvider theme={muiTheme}>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperComponent={(props) => (
          <Paper
            {...props}
            sx={(theme) => ({
              borderTop: `4px solid ${theme.palette.error.main}`,
            })}
          />
        )}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4" component="span">
            {title || "Error"}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body1" component="span">
              {message || "An unexpected error occurred."}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
